const newEcommerce = {
  enabled: false /** primero sale solo para Mexico */,
}

export default newEcommerce
